import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import SubmitForm from './SubmitForm'
import Inputmask from 'inputmask'
import $ from 'jquery';
import toastr from 'toastr'
import Autocomplete from "react-google-autocomplete";
import states from './states.json'
import PhoneField from '../PhoneField';
function Step6({ validateField }) {

    setTimeout(() => {
        const arr = document.querySelectorAll('[data-inputmask]');
        let options = { 'placeholder': '' };
        Inputmask(options).mask(arr);
    }, 500);

    const authContext = useContext(AuthContext);
    let { lead, gotoNextStep, step } = authContext;
    let owner = lead.owners[0];
    const initialState = {
        address: owner.address ? owner.address : '',
        address_apartment: owner.address_apartment ? owner.address_apartment : '',
        zip: owner.zip ? owner.zip : '',
        phone: owner.phone ? owner.phone : '',
        phone_extension: owner.phone_extension ? owner.phone_extension : '+1',
        title: owner.title ? owner.title : '',
        email: owner.email ? owner.email : '',
        first_name: owner.first_name,
        last_name: owner.last_name,
        city: owner.city ? owner.city : '',
        state: owner.state ? owner.state : '',
        date_of_birth: owner.date_of_birth ? owner.date_of_birth : null,
        // ownership_percentage: owner.ownership_percentage ? owner.ownership_percentage : '',
        short_address: owner.short_address ? owner.short_address : '',
        has_suite: owner.address_apartment ? true : false
    }

    const [fields, setFields] = useState(initialState);
    const handleChange = (event, isCustom) => {
        let target;
        // console.log(event, isCustom);
        if (!isCustom) {
            target = event.target;
        } else {
            target = event;
        }
        let value = target.value;
        let index = target.name;
        validateField(target);
        setFields(fields => {
            return { ...fields, [index]: value }
        });
    }
    const handlePrepopulate = (result, e) => {
        // console.log(result);
        let $hasZip, $hasCity, $hasState, $short_address = '';
        if (result.address_components) {
            result.address_components.forEach(element => {
                // console.log(element);
                if (element.types.includes("postal_code")) {
                    $hasZip = 1;
                    var $el = document.getElementsByName('zip')[0];
                    $el.value = element.long_name;
                    handleChange($el, 'custom');
                }
                if (element.types.includes("locality") || element.types.includes("political") && $hasCity !== 1) {
                    $hasCity = 1;
                    var $el = document.getElementsByName('city')[0]
                    $el.value = element.long_name;
                    handleChange($el, 'custom');
                }
                if ((element.types.includes("sublocality_level_1") || element.types.includes("sublocality")) && $hasCity !== 1) {
                    var $el = document.getElementsByName('city')[0];
                    $el.value = element.long_name;
                    $hasCity = 1;
                    handleChange($el, 'custom');

                }
                if (element.types.includes("administrative_area_level_1")) {
                    var $el = document.getElementsByName('state')[0];
                    $el.value = element.short_name;
                    $hasState = 1;
                    handleChange($el, 'custom');
                }
                if (element.types.includes("street_number")) {
                    $short_address += element.long_name + ' ';
                }
                if (element.types.includes("route")) {
                    $short_address += element.long_name;
                }
            });
            if ($hasZip === 1) {
                $('#zipCol').addClass('d-none');
            } else {
                $('#zipCol').removeClass('d-none');
            }
            if ($hasCity === 1) {
                $('#cityCol').addClass('d-none');
            } else {
                $('#cityCol').removeClass('d-none');
            }
            if ($hasState === 1) {
                $('#stateCol').addClass('d-none');
            } else {
                $('#stateCol').removeClass('d-none');
            }
            e.value = result.formatted_address.replace(', USA', '');
            handleChange(e, 'custom');
            setFields(fields => {
                return { ...fields, short_address: $short_address }
            });

        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const $array = Object.keys(fields);
        const $errorbag = [];
        // console.log($array);
        $array.map((item) => {
            const target = document.getElementsByName(item)[0];
            if (target) {
                let $result = validateField(target);
                // console.log(target,$result);
                if ($result) {
                    $errorbag.push($result);
                }
            }
            return null;
        });
        if ($errorbag.length === 0) {
            gotoNextStep(fields, step);
        } else {
            let $format = '';
            $errorbag.map((error, i) => {
                const $err = error + '<br/>';
                $format += $err;
                return null;
            })
            toastr.error($format);
        }
    }
    const handlePercentage = (event) => {
        event.preventDefault();

        let $label = $(event.target),
            $element = $label.find('input'),
            $value = $element.val();
        // console.log($value);
        $element.parent().addClass('active').siblings('.btn').removeClass('active')
        $('#perc_col').removeClass('is-invalid');
        if ($value == '100%') {
            $('#collapseDiv').hide();
            setFields({
                ...fields, ownership_percentage: $value
            });
        } else {
            $('#collapseDiv').show();
            setFields({
                ...fields, ownership_percentage: null
            });
        }


    }
    const checkDate = (event) => {
        let $result = validateField(event.target);
        if ($result) {
            toastr.error($result);
        }
    }

    let PercentageOptions = []
    let $i;
    for ($i = 99; $i >= 1; $i--) {
        PercentageOptions.push(<option key={$i} value={$i + '%'}> {$i} %</option >);
    }
    const gmaps = 'AIzaSyCpc5j5FV6ESKlrunh4QHmHAVmN1z6QZ8E';
    const handleShowSuite = () => {
        setFields(fields => {
            if (fields.has_suite == true) {
                return { ...fields, has_suite: !fields.has_suite, address_apartment: null }
            }
            return { ...fields, has_suite: !fields.has_suite }
        });
    }
    return (
        <>
            <form onSubmit={e => handleSubmit(e)}>
                <div className="container">
                    <div className="row">
                        <div className="mb-3 col-md-4">
                            <label htmlFor="first_name">Owner First Name</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="far fa-user"></i></span>
                                <input type="text" name="first_name" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.first_name || ''} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-4">
                            <label htmlFor="last_name">Owner Last Name</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="far fa-user"></i></span>
                                <input type="text" name="last_name" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.last_name || ''} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-4">
                            <label htmlFor="phone">Owner Phone</label>
                            <PhoneField handleChange={handleChange} phone={{ name: 'phone', value: fields.phone }} extension={{ value: fields.phone_extension, name: 'phone_extension' }} />

                            {/* <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-phone"></i></span>
                                <input type="tel" inputMode="numeric" name="phone" data-inputmask="'mask': '(999) 999-9999'" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.phone || ''} />
                            </div> */}
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="email">Owner Email</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="far fa-envelope-open"></i></span>
                                <input type="text" name="email" placeholder="example@email.com" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.email || ''} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-8">
                            <label htmlFor="address">Owner Home Address</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-marked-alt"></i></span>
                                <Autocomplete
                                    apiKey={gmaps}
                                    value={fields.address}
                                    className="form-control"
                                    name="address"
                                    onChange={e => handleChange(e)}
                                    options={{
                                        fields: ['address_components', 'formatted_address'], types: ['geocode'], componentRestrictions: { country: "us" },
                                    }}
                                    onPlaceSelected={(place, e) => handlePrepopulate(place, e)}
                                />


                                <input type="text" className="d-none" name="address" defaultValue={fields.address} />
                            </div>
                            <p className="text-muted pb-0 mb-0">Street address <small className="float-right" onClick={() => handleShowSuite()} style={{ cursor: "pointer", userSelect: 'none' }}>
                                {fields.has_suite ? '- Remove Apartment/Unit #' : '+ Add Apartment/Unit #'
                                }</small>
                            </p>

                            <div className={"form-group" + (fields.has_suite ? '' : ' d-none')}>
                                <label htmlFor="address_apartment">Apartment/Unit #</label>
                                <div className="input-group">
                                    <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                    <input type="text" name="address_apartment" placeholder="#" onChange={e => handleChange(e)}
                                        className="form-control" value={fields.address_apartment} />
                                </div>
                            </div>
                        </div>

                        <div className="mb-3 col-md-4 d-none" id="cityCol">
                            <label htmlFor="city">Owner Home City</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                <input type="text" name="city" onChange={e => handleChange(e)}
                                    className="form-control"
                                    value={fields.city || ''} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-4 d-none" id="stateCol">
                            <label htmlFor="state">Owner State</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                <select className="custom-select" name="state"
                                    onChange={e => handleChange(e)} defaultValue={fields.state}>
                                    <option value="" disabled>Select state...</option>
                                    {Object.entries(states).map((i, val) =>
                                        <option key={val} value={i[0]}>{i[1]}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="mb-3 col-md-4 d-none" id="zipCol">
                            <label htmlFor="zip">Owner Zip Code</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-marked-alt"></i></span>
                                <input type="tel" inputMode="numeric" placeholder="12345" name="zip" onChange={e => handleChange(e)}
                                    className="form-control" data-inputmask="'mask': '99999'" value={fields.zip || ''} />
                            </div>
                        </div>

                        <div className="mb-3 col-md-4">
                            <label htmlFor="title">Title</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-user-tie"></i></span>
                                <select className="custom-select" name="title"
                                    onChange={e => handleChange(e)} defaultValue={fields.title || ''}>
                                    <option value="" disabled>Select title...</option>
                                    <option value="Owner">Owner</option>
                                    <option value="President">President</option>
                                    <option value="CEO">CEO</option>
                                    <option value="Vice President">Vice President</option>
                                    <option value="Secretary/Treasurer">Secretary/Treasurer</option>
                                    <option value="Managing Member">Managing Member</option>
                                    <option value="Partner">Partner</option>
                                </select>
                            </div>
                        </div>
                        <div className="mb-3 col-md-4 order-1 order-md-0">
                            <label htmlFor="date_of_birth">Date of Birth <small>(mm/dd/yyyy)</small></label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="far fa-calendar-alt"></i></span>

                                <input type="tel" inputMode="numeric" name="date_of_birth" onChange={e => handleChange(e)}
                                    className="form-control" placeholder="mm/dd/yyyy" data-inputmask="'mask': '99/99/9999'" onBlur={e => checkDate(e)} value={fields.date_of_birth || ''} />
                            </div>
                        </div>
                        {/* <div className="mb-3 col-md-4" id="perc_col">
                            <label htmlFor="">Ownership Percentage</label>
                            <div className="btn-toggle d-block percent_buttons">

                                <label onClick={e => handlePercentage(e)}
                                    className={"btn btn-light bg-button " + (fields.ownership_percentage == '100%' ? 'active' : '')} htmlFor='option1'>
                                    <input type="radio"
                                        onChange={e => console.log('')}
                                        value='100%'
                                        checked={fields.ownership_percentage == '100%' ? true : false}
                                        name='ownership_perc'
                                        id='option1' /> 100%

                                </label>
                                <label htmlFor='option2' className={"btn btn-light bg-button " + (fields.ownership_percentage && fields.ownership_percentage != '100%' ? 'active' : '')} onClick={e => handlePercentage(e)} >
                                    <input type="radio"
                                        onChange={e => console.log('')}
                                        value='other'
                                        checked={fields.ownership_percentage && fields.ownership_percentage != '100%' ? true : false}
                                        name='ownership_perc'
                                        id='option2' /> Other</label>
                            </div>
                            <div className={"collapse mt-2 " + (fields.ownership_percentage && fields.ownership_percentage != '100%' ? 'show' : '')} id="collapseDiv">
                                <label htmlFor="address">Please Choose Below</label>
                                <div className="input-group">
                                    <span className="input-group-text"><i className="fas fa-map-marked-alt"></i></span>
                                    <select className="form-control" name="ownership_percentage"
                                        onChange={e => handleChange(e)} value={fields.ownership_percentage || ''}>
                                        <option value="" disabled>Select percentage...</option>
                                        {PercentageOptions}
                                    </select>
                                </div>
                            </div>
                        </div> */}



                    </div>

                    <SubmitForm />
                </div >

            </form >
        </>
    )
}

export default Step6
